import React, { useState } from 'react'

function NumericKeyPad({ displayNumber, setDisplayNumber, maxString, placeHolderInput }) {
   //the state is declared in father component (displayNumber, setDisplayNumber)

   const handleNumberClick = (number) => {
      if (maxString == undefined) {
         setDisplayNumber((prevDisplayNumber) => prevDisplayNumber + number);
      } else {
         if (displayNumber.length < maxString) {
            setDisplayNumber((prevDisplayNumber) => prevDisplayNumber + number);
         }
      }
   };

   const handleClearClick = () => {
      setDisplayNumber('');
   };



   return (
      <>
         {/* <div className='keyboard-main'>
            <div className='keyboard-pad d-flex flex-wrap'>
               <input type="text"

                  className='keypadPrimary-input_1   my-2 text-center'
                  placeholder={placeHolderInput == undefined ? '6000-0000' : placeHolderInput} value={displayNumber} readOnly
                  maxLength="4"
               />
               <button className='key-num-pin pulse' onClick={() => handleNumberClick('1')}>1</button>
               <button className='key-num-pin pulse' onClick={() => handleNumberClick('2')}>2</button>
               <button className='key-num-pin ' onClick={() => handleNumberClick('3')}>3</button>

               <button className='key-num-pin pulse' onClick={() => handleNumberClick('4')}>4</button>
               <button className='key-num-pin pulse' onClick={() => handleNumberClick('5')}>5</button>
               <button className='key-num-pin pulse' onClick={() => handleNumberClick('6')}>6</button>

               <button className='key-num-pin pulse' onClick={() => handleNumberClick('7')}>7</button>
               <button className='key-num-pin pulse' onClick={() => handleNumberClick('8')}>8</button>
               <button className='key-num-pin pulse' onClick={() => handleNumberClick('9')}>9</button>

             
               <button className='key-num-pin pulse' onClick={() => handleClearClick()}>
                  <i class="uil uil-backspace"></i>
               </button>
               <button className='key-num-pin pulse' onClick={() => handleNumberClick('0')}>0</button>


            </div>
         </div> */}

         <div className="vmkp-root">

            {/* Display del valor actual */}
            <div className="vmkp-display">
               <span className="vmkp-display-label">
                  <i className="uil uil-keyhole-circle"></i>
                  Ingresa el código
               </span>
               {/* <input
                  type="text"
                  className="vmkp-display-input"
                  placeholder={placeHolderInput == undefined ? '0000' : placeHolderInput}
                  value={displayNumber}
                  readOnly
                  maxLength="4"
               /> */}

               <input
                  type="text"
                  className="vmkp-display-input"
                  placeholder={placeHolderInput == undefined ? '0000' : placeHolderInput}
                  value={
                     displayNumber && displayNumber.length > 0
                        ? '•'.repeat(Math.max(0, displayNumber.length - 1)) + displayNumber.slice(-1)
                        : ''
                  }
                  readOnly
                  maxLength="4"
               />
               {/* Dots de progreso (4 posiciones por maxLength=4) */}
               <div className="vmkp-display-dots" aria-hidden="true">
                  {[0, 1, 2, 3].map((i) => (
                     <span
                        key={i}
                        className={`vmkp-display-dot ${displayNumber && displayNumber.length > i ? 'is-filled' : ''}`}
                     />
                  ))}
               </div>
            </div>

            {/* Keypad 3x4 — números + backspace + 0 */}
            <div className="vmkp-keypad">
               <button className="vmkp-key vmkp-key-num" onClick={() => handleNumberClick('1')}>1</button>
               <button className="vmkp-key vmkp-key-num" onClick={() => handleNumberClick('2')}>2</button>
               <button className="vmkp-key vmkp-key-num" onClick={() => handleNumberClick('3')}>3</button>

               <button className="vmkp-key vmkp-key-num" onClick={() => handleNumberClick('4')}>4</button>
               <button className="vmkp-key vmkp-key-num" onClick={() => handleNumberClick('5')}>5</button>
               <button className="vmkp-key vmkp-key-num" onClick={() => handleNumberClick('6')}>6</button>

               <button className="vmkp-key vmkp-key-num" onClick={() => handleNumberClick('7')}>7</button>
               <button className="vmkp-key vmkp-key-num" onClick={() => handleNumberClick('8')}>8</button>
               <button className="vmkp-key vmkp-key-num" onClick={() => handleNumberClick('9')}>9</button>

               <button
                  className="vmkp-key vmkp-key-back"
                  onClick={() => handleClearClick()}
                  aria-label="Borrar"
               >
                  <i className="uil uil-backspace"></i>
               </button>
               <button className="vmkp-key vmkp-key-num" onClick={() => handleNumberClick('0')}>0</button>
               <span className="vmkp-key vmkp-key-empty" aria-hidden="true" />
            </div>
         </div>
      </>
   )
}

export default NumericKeyPad